import { createFileRoute } from "@tanstack/react-router";
import { CredentialEditPage } from "@client/components/tool-workshop/credential-edit-page";

export const Route = createFileRoute("/_app/bots/credentials/new")({
  component: CredentialEditPage,
});
